export function parseAmountToBaseUnits(input: string, decimals: number): bigint | null {
  const trimmed = input.trim();
  if (!/^\d+(\.\d+)?$/.test(trimmed)) return null;

  const [whole, fraction = ''] = trimmed.split('.');
  if (fraction.length > decimals) return null;

  const baseUnits =
    BigInt(whole) * 10n ** BigInt(decimals) + BigInt(fraction.padEnd(decimals, '0') || '0');
  return baseUnits > 0n ? baseUnits : null;
}

export function isPositiveAmountWithinBalance(input: string, balance: BigNumber): boolean {
  const amount = new BigNumber(input);
  return amount.isFinite() && amount.isGreaterThan(0) && amount.isLessThanOrEqualTo(balance);
}
import { BigNumber } from 'bignumber.js';
